import React from 'react';

import './strength.scss';

const scoreMapping = {
  short: {
    text: 'Too short',
    className: 'too-short',
  },
  0: {
    text: 'Too weak',
    className: 'very-weak',
  },
  1: {
    text: 'Weak',
    className: 'weak',
  },
  2: {
    text: 'Fair',
    className: 'fair',
  },
  3: {
    text: 'Strong',
    className: 'strong',
  },
  4: {
    text: 'Strong',
    className: 'strong',
  },
};

const Strength = ({ score }) => {
  if (!score && score !== 0) return;
  const scoreData = scoreMapping[score];

  return (
    <div className={`strength ${scoreData.className}`}>
      <p className="strength-text">{scoreData.text}</p>
      <div className="meter">
        <div className="base-line"></div>
        <div className="dynamic-line"></div>
      </div>
    </div>
  );
};

export default Strength;
